import { useEffect, useState, useMemo, useRef } from 'react';

import { useHistory } from "react-router-dom";
import { ListViewComponent } from '@syncfusion/ej2-react-lists';
import { useForm } from "react-hook-form";
import { useStateMachine } from "little-state-machine";
import updateAction from "./updateAction";
import dayjs from 'dayjs';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

export default function BookDate(props) {
    let history = useHistory();
    const acrdnRef = useRef()
    const sp = `${process.env.REACT_APP_LOCAL_SERVER}/php/onlinebooking`;
    //const blankSlots = useMemo(() => { return { counts: [], day0: { slot: [] }, day1: { slot: [] }, day2: { slot: [] }, day3: { slot: [] }, day4: { slot: [] }, day5: { slot: [] }, day6: { slot: [] } } }, []);
    const blankSlots = useMemo(() => { return { counts: [], slots: {} } }, []);
    const [availList, setAvailList] = useState({});
    const [searchDate, setSearchDate] = useState(dayjs().format('YYYYMMDD'));
    const [prevWeek, setPrevWeek] = useState();
    const [nextWeek, setNextWeek] = useState();
    const { handleSubmit, setValue, getValues } = useForm();
    const { actions, state } = useStateMachine({ updateAction });

    useEffect(() => {
        async function fetchData() {

            //setAvailList({});

            console.log(sp + `/find_times.php?practice_id=${localStorage.getItem('practice_id')}&reason=${state.reason}&duration=${state.duration}&resource=${state.clinician}&date=${searchDate}`);

            fetch(sp + `/find_times.php?practice_id=${localStorage.getItem('practice_id')}&reason=${state.reason}&duration=${state.duration}&resource=${state.clinician}&date=${searchDate}`)
                .then(async response => {

                    const availListResult = await response.json();
                    if (availListResult.error) {
                        alert("Error: " + availListResult.error);
                        return;
                    }

                    setPrevWeek(dayjs(availListResult.prev_week, 'MM/DD/YYYY').format('YYYYMMDD'));
                    setNextWeek(dayjs(availListResult.next_week, 'MM/DD/YYYY').format('YYYYMMDD'));

                    //console.log(availListResult);

                    setAvailList(availListResult.slots);

                    /*if (availListResult.avail) {

                        let avail = availListResult.avail;
                        if (!avail.day0.slot)
                            avail.day0.slot = [];
                        else if (Array.isArray(avail.day0.slot) === false)
                            avail.day0.slot = [avail.day0.slot];

                        if (!avail.day1.slot)
                            avail.day1.slot = [];
                        else if (Array.isArray(avail.day1.slot) === false)
                            avail.day1.slot = [avail.day1.slot];

                        if (!avail.day2.slot)
                            avail.day2.slot = [];
                        else if (Array.isArray(avail.day2.slot) === false)
                            avail.day2.slot = [avail.day2.slot];

                        if (!avail.day3.slot)
                            avail.day3.slot = [];
                        else if (Array.isArray(avail.day3.slot) === false)
                            avail.day3.slot = [avail.day3.slot];

                        if (!avail.day4.slot)
                            avail.day4.slot = [];
                        else if (Array.isArray(avail.day4.slot) === false)
                            avail.day4.slot = [avail.day4.slot];

                        if (!avail.day5.slot)
                            avail.day5.slot = [];
                        else if (Array.isArray(avail.day5.slot) === false)
                            avail.day5.slot = [avail.day5.slot];

                        if (!avail.day6.slot)
                            avail.day6.slot = [];
                        else if (Array.isArray(avail.day6.slot) === false)
                            avail.day6.slot = [avail.day6.slot];

                        setAvailList(avail);
                    }*/

                })
                .catch(error => {
                    //setPageError(true);
                    //console.error('There was an error!', error);
                });

        }

        if (props.tabIndex === 1)
            fetchData();
    }, [props.tabIndex, blankSlots, searchDate, sp, state.clinician, state.duration, state.reason]);

    useRef(() => {
        acrdnRef.current.refresh();
    }, [availList])

    const onSubmit = data => {
        if (getValues('selected_time')) {
            actions.updateAction(data);
            props.finishFnc(state);
        } else {
            alert('You need to choose a time to continue');
        }
    };

    function chooseTime(data) {
        //console.log(data);
        //console.log(availList[event.index]);
        setValue('selected_date', data.dbdate);
        setValue('selected_time', data.dbtime);
        setValue('clinician', data.resourceid);
        setValue('clinician_name', data.resource);
        //handleSubmit(onSubmit)();
    }

    function chooseDate(date) {
        //console.log(nextWeek);
        //console.log(dayjs(nextWeek, 'YYYYMMDD'));

        if (date === 'prev')
            setSearchDate(prevWeek);
        else if (date === 'next')
            setSearchDate(nextWeek);
    }

    const timeTemplate = data => {
        return (
            <div onClick={() => chooseTime(data)}>{data.starttime} with {data.resource} for {data.duration} minutes
            </div>
        )
    }

    return (
        <div>
            <form>
                <h4 className="booking-text">Choose an appointment time, then click continue</h4>
                <div className="dates-container">
                    <div className="dates-header">
                        {/* {(prevWeek >= dayjs().format('YYYYMMDD')) && <button className="booking-change-week-btn" type="button" onClick={() => chooseDate('prev')}>Previous Week ({dayjs(prevWeek, 'YYYYMMDD').format('ddd Do MMM')} onwards)</button>} */}
                        {(prevWeek >= dayjs().format('YYYYMMDD')) && <button className="booking-change-week-btn" type="button" onClick={() => chooseDate('prev')}><div className="booking-change-week-text"><ArrowBackIcon fontSize="large" style={{ marginRight: "10px" }} />Previous Week <br /> {dayjs(prevWeek, 'YYYYMMDD').format('ddd Do MMM')}</div></button>}
                        <button className="booking-change-week-btn" type="button" onClick={() => chooseDate('next')}><div className="booking-change-week-text">
                            Next Week <br /> {dayjs(nextWeek, 'YYYYMMDD').format('ddd Do MMM')}
                            <ArrowForwardIcon fontSize="large" style={{ marginLeft: "10px" }} />
                        </div></button>
                    </div>
                    { !availList &&
                    <div>There are no avaiable appointments this week, please try the next week</div>
                    }
                    <ListViewComponent
                        dataSource={availList}
                        height="100%"
                        fields={{ text: 'starttime', value: 'starttime', groupBy: 'date' }}
                        template={timeTemplate}
                    />

                    <div className="space-between-mobile">
                        <button className="booking-btns" type="button" onClick={() => handleSubmit(onSubmit)()} >Continue</button>
                        <button className="booking-btns" type="button" onClick={() => history.push(`/home`)}>Cancel</button>
                    </div>
                </div>
            </form>
        </div>
    )
}